/**
 * Workspace seats — included seats per plan, paid add-on rates, and rollout flag.
 * Keep in sync with Stripe Price IDs used in Cloud Functions billing.
 */

/** When false: seats UI/backend callables hidden; Phase 2 can ship incrementally */
export const WORKSPACE_SEATS_ENABLED = true;

export const INCLUDED_SEATS_FREE = 1;
export const INCLUDED_SEATS_PROFESSIONAL = 1;
export const INCLUDED_SEATS_STUDIO = 3;

/** Monthly USD per seat beyond included (Stripe add-on recurring price) */
export const EXTRA_SEAT_PRICE_USD_PROFESSIONAL = 29;
export const EXTRA_SEAT_PRICE_USD_STUDIO = 25;
